import { render, staticRenderFns } from "./DeliverySltExt.vue?vue&type=template&id=1ab52eb4&scoped=true&"
import script from "./DeliverySltExt.vue?vue&type=script&lang=js&"
export * from "./DeliverySltExt.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySltExt.vue?vue&type=style&index=0&id=1ab52eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab52eb4",
  null
  
)

export default component.exports